import React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { Illustration } from '@winnin/winnin_ui.components.illustration'

import './index.scss'

const ComingSoonMessage = observer(({ message }) => {
  const containerClass = classNames('coming-soon-container')

  return (
    <div className={containerClass}>
      <Illustration name="comingSoon" />

      <div className="text-container">
        <h5>Coming soon!</h5>
        <p>{message || ''}</p>
      </div>
    </div>
  )
})

ComingSoonMessage.propTypes = {}

ComingSoonMessage.defaultProps = {}

ComingSoonMessage.displayName = 'ComingSoonMessage'

export default ComingSoonMessage
